/**
 * รูปประกอบโจทย์ (D23) — แสดงเหนือ stem ทั้งหน้าทำข้อสอบและหน้าเฉลย
 *
 * ★ สตริง SVG จากไฟล์เนื้อหา **ไม่เคยแตะ innerHTML** — `sanitizeFigure` ประกอบ
 *   element ขึ้นใหม่ตาม allowlist แล้วเรา appendChild ตัวที่ประกอบเสร็จ
 * ★ ไม่ผ่านด่าน = ไม่เรนเดอร์อะไรเลย (ไม่มี element ใน DOM) ไม่ใช่กล่องเปล่า
 * ★ สีของเส้นเป็นของรูปเอง (คนวาดใช้ `stroke="currentColor"`) เราไม่บังคับสีให้
 *   จึงเปลี่ยนตามธีมของหน้าที่มันไปอยู่โดยอัตโนมัติ
 */
import { useEffect, useMemo, useRef } from "react";

import { sanitizeFigure } from "@/lib/figure";

export function Figure({
  svg,
}: {
  svg: string | null | undefined;
}): JSX.Element | null {
  const host = useRef<HTMLDivElement | null>(null);
  const safe = useMemo(() => sanitizeFigure(svg), [svg]);

  useEffect(() => {
    const box = host.current;
    if (!box) return;
    box.replaceChildren();
    if (safe) box.appendChild(safe);
    return () => box.replaceChildren();
  }, [safe]);

  if (!safe) return null;
  return <div className="figure" data-testid="figure" ref={host} />;
}
